<template>
  <div class="mb-1">
    <div class="text-center mb-1 pt-3">
      <el-radio-group
        v-model="field.is_global_variable"
        style="background: var(--brand-500) !important"
        class="text-white rounded-md border-none"
      >
        <el-radio-button :label="false" class="border-none px-1">
          <span class="text-white font-normal border-none">Custom Field</span>
        </el-radio-button>
        <!-- <el-radio-button :label="true">Global Variable</el-radio-button> -->
      </el-radio-group>
    </div>

    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'templates-formComponents-SingleLineText',
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      // "IsFieldRequired":()=>import("./IsFieldRequired"),
      // "FieldFilledBy":()=>import("./FieldFilledBy"),
      // "Placeholder":()=>import("./Placeholder"),
      // "FieldAttributes":()=>import("./FieldAttributes.vue")
    },

    props: ['field', 'fieldsData'],
    computed: {},
    mounted() {
      // this.fetchGlobalVaribales();
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style lang="scss"></style>
